import { combineReducers } from 'redux'

import { SUBMIT_ENCRYPTION_DEMO_REQUEST } from './constants'

const initialState = {
  demoRequested: false,
  isLoading: false,
  error: null,
}

const encryptionPLGReducer =
  () =>
  (state = initialState, action = {}) => {
    if (!action?.type) {
      return state
    }

    switch (action.type) {
      case SUBMIT_ENCRYPTION_DEMO_REQUEST.INITIATE:
        return {
          ...state,
          isLoading: true,
          error: null,
        }

      case SUBMIT_ENCRYPTION_DEMO_REQUEST.SUCCESS:
        return {
          ...state,
          demoRequested: true,
          isLoading: false,
          error: null,
        }

      case SUBMIT_ENCRYPTION_DEMO_REQUEST.ERROR:
        return {
          ...state,
          isLoading: false,
          error: action.error,
        }

      default:
        return state
    }
  }

export default function reducer() {
  // eslint-disable-next-line no-shadow
  const initialState = combineReducers({
    self: encryptionPLGReducer(),
  })

  return (state = initialState) => state
}
